import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
    BehaviorSubject,
    combineLatest,
    EMPTY,
    forkJoin,
    from,
    merge,
    Observable,
    of,
    OperatorFunction,
    pipe,
    ReplaySubject,
    Subject,
    throwError
} from 'rxjs';
import {
    ALGORITHM_CAPPED_VAI,
    ALGORITHM_THOUSANDTH,
    ALGORITHM_VAI,
    ECComputedCommunityEconomics,
    ECEconomicsFanoRedistributionSettings,
    ECEconomicsMixedRedistributionSettings,
    ECEconomicsNewCondoRedistributedPropertyUnitIncentivationAlgorithm,
    ECEconomicsNewCondoRedistributionSettings,
    ECEconomicsRedistributedIncentivation,
    ECEconomicsRedistributedMember,
    ECEconomicsRedistributedPerformance,
    ECEconomicsRedistributedResponse,
    ECEconomicsRedistributedRows,
    ECEconomicsStrategyFeatures,
    ECO_ERROR_PARAM_KEY,
    EconomicsErrorType,
    ECSurplusPremiumRateScope,
    REDISTRIBUTION_WARNING_PARTIALLY_RELEVANT_MEMBERS,
    STRATEGY_NEW_CONDO,
    STRATEGY_OLD_CONDO
} from 'smag-commons/dto/eco';
import {Router} from '@angular/router';
import * as moment from 'moment-timezone';
import {Moment} from 'moment-timezone';
import {
    CAP as CAP_KEY,
    EC_FILE_EXPORT_CONDO_OLD_AUC_STANDARD,
    EC_FILE_MIXED,
    EC_FILE_THOUSANDTHS,
    ECMember,
    ECMemberRelationType,
    ECMemberSubjectClassification,
    ECMode,
    EnergyCommunity,
    EntityType,
    Pod,
    THOUSANDTHS
} from 'smag-commons/cfg/hierarchy';
import {catchError, distinctUntilChanged, filter, first, map, shareReplay, startWith, switchMap, takeUntil, tap} from 'rxjs/operators';
import {
    ALGORITHM_CONDO_NEW,
    ALGORITHM_CONDO_OLD,
    ALGORITHM_FANO,
    ALGORITHM_MIXED,
    ALGORITHM_NO_ALGORITHM,
    ALGORITHM_NO_ALGORITHM_NEW_CONDO,
    ALGORITHM_NO_ALGORITHM_OLD_CONDO,
    ECEconomicsCappedVAIRedistributionSettings,
    ECEconomicsCondoNewStrategyInfo,
    ECEconomicsFanoRedistributedPodIncentivationAlgorithm,
    ECEconomicsFeatures,
    ECEconomicsNewCondoRedistributedPodIncentivationAlgorithm,
    ECEconomicsOldCondoRedistributedPodIncentivationAlgorithm,
    ECEconomicsOldCondoRedistributionSettings,
    ECEconomicsPerformance,
    ECEconomicsRedistributedNewCondoRow,
    ECEconomicsRedistributedPod,
    ECEconomicsRedistributedPropertyUnit,
    ECEconomicsRedistributionSettings,
    ECEconomicsSurplusPremiumRate,
    ECEconomicsThousandthRedistributionSettings,
    ECEconomicsVAIRedistributionSettings,
    ECPodDataSource,
    ECSurplusPremiumRate,
    REDISTRIBUTION_WARNING_MIXED_INSUFFICIENT_REVENUE
} from 'smag-commons/dto/eco/community';
import {MatPaginator, MatPaginatorIntl} from '@angular/material/paginator';
import {MsgBoxService} from '../../../shared/msg-box.service';
import {I18NService} from '../../../i18n/i18n.service';
import {EconomicsError} from 'smag-commons/dto/eco/errors';
import {I18NMatPaginatorIntl, I18NMatPaginatorIntlConfig} from '../../../shared/i18n-mat-paginator-intl';
import {Dialog, DialogService} from '../../../shared/dialog/dialog.service';
import {ValueObjectType} from 'smag-commons/cfg/value';
import {SelectedAlgorithm} from './algorithm/ec-algorithm.component';
import * as _ from 'lodash';
import {
    COSTS,
    EC_PLANTS_REI_REDISTRIBUTION,
    PLANT_TIP_QUOTE,
    REDISTRIBUTION_SETTINGS,
    SEU_FIX_QUOTA,
    STRATEGY,
    SURPLUS_PREMIUM_RATE_MODE
} from 'smag-commons/cfg/economics-values';
import {EnergyCommunityNetwork, Permission} from 'smag-commons/dto/api';
import {MatDialog} from '@angular/material/dialog';
import {CAP} from './cap-selector/cap-selector.component';
import {isConsumer, isProsumer} from 'smag-commons/fcn';
import {EconomicsErrorCode} from '../../../api/errors';
import {can} from '../../../shared/permissions';
import {HierarchyEntity, HierarchyService} from '../../../shared/hierarchy.service';
import {ConfigurationService} from '../../../shared/configuration.service';
import {downloadBlob, errorCode, isDefined, isNumber} from '../../../commons/commons';
import {SmagApiService} from '../../../api/smag-api.service';
import {mkLandRegistryDataString, mkMode, showPropertyUnit} from '../../../shared/energy-community';
import {BillingPeriod, BillingPeriodConfig} from '../billing-filter/ec-billing-filter.component';
import {
    CACV_STRING,
    CHAD_DIALOG_MAX_WIDTH,
    CHAD_DIALOG_MIN_WIDTH,
    ChartOptions,
    DEFAULT_DIALOG_MAX_WIDTH,
    DEFAULT_DIALOG_MIN_WIDTH,
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGE_SIZES,
    disableDataLabels,
    disableLegend,
    getAlgoDialogWidth,
    getNiceTooltip,
    getPodType,
    getSubjectName,
    getTranslatedLabels,
    GIGA_CHAD_DIALOG_MAX_WIDTH,
    isNoAlgorithm,
    isUpdatable,
    isViewable,
    isWholeYearSelected,
    keepYourSecrets,
    mkAbsorptionParticipationChart,
    mkBillingPeriodParams,
    mkConsolidatedMonths,
    mkPersonalSharingChart,
    mkYearlyValue,
    sanityFromTimeActivationDate,
    sanityToTime,
    showNullData,
    YearSummaryConsolidation
} from '../../../shared/ec-economics';
import {NiceValuePipe} from '../../../shared/shared.pipe';
import {environment} from '../../../../environments/environment';
import {YearlyValue} from 'smag-commons/cfg/value/yearly-value';
import {ComputationStatusService} from '../../../shared/compute-status.service';
import {SpinnerData} from '../../../shared/spinner/spinner.component';
import {EconomicsConfig} from 'smag-commons/cfg';
import {
    EC_FILE_EXPORT_CONDO_NEW_LAYOUT_1,
    EC_FILE_EXPORT_CONDO_NEW_LAYOUT_2,
    EC_FILE_EXPORT_CONDO_NEW_LAYOUT_3
} from 'smag-commons/cfg/hierarchy/ec';

interface RedistributedPod extends ECEconomicsRedistributedPod {
    seu: boolean;
}

interface RedistributedPropertyUnit extends ECEconomicsRedistributedPropertyUnit {
    name: string;
    seu: boolean;
}

interface RedistributedMember {
    member: ECMember;
    pod: RedistributedPod;
    propertyUnit: RedistributedPropertyUnit;
    roles?: ECMemberRelationType[];
    isConsumer: boolean;
    subjectName: string;
}

interface RedistributedRows {
    members: RedistributedMember[];
    total: number;
    errors?: EconomicsError[];
}

export interface CappedVAIRedistributionPODSettings {
    cap?: number;
}

const MEMBERS_COLUMN = 'members';
const TOTAL_COLUMN = 'total';
const DETAILS_COLUMN = 'details';
const MEMBERS_SHARE_COLUMN = 'members_share';

const BASE_COLUMNS = [MEMBERS_COLUMN, 'personal_sharing'];
const DEFAULT_COLUMNS = [...BASE_COLUMNS, TOTAL_COLUMN];
const THOUSANDTH_COLUMNS = [...BASE_COLUMNS, 'thousandths', TOTAL_COLUMN, DETAILS_COLUMN];
const ENERGY_AND_PERFORMANCE_COLUMNS = ['energy_sharing', 'performance_incentive'];
const INNER_VAI_COLUMNS = [...ENERGY_AND_PERFORMANCE_COLUMNS, 'fixed_part'];
const INNER_MIXED_COLUMNS = ['mixed_fixed', 'mixed_percentage', 'mixed_performance'];
const VAI_COLUMNS = [...BASE_COLUMNS, ...INNER_VAI_COLUMNS, TOTAL_COLUMN, DETAILS_COLUMN];
const CAPPED_VAI_COLUMNS = [...BASE_COLUMNS, ...INNER_VAI_COLUMNS, 'CAP', TOTAL_COLUMN, 'CAP_settings', DETAILS_COLUMN];
const MIXED_COLUMNS = [...BASE_COLUMNS, ...INNER_MIXED_COLUMNS, TOTAL_COLUMN, DETAILS_COLUMN];
const NULL_REDIST_COLUMNS = [MEMBERS_COLUMN, TOTAL_COLUMN];
const FANO_COLUMNS = [...BASE_COLUMNS, 'absorbed_energy', 'performance_incentive', MEMBERS_SHARE_COLUMN, TOTAL_COLUMN, DETAILS_COLUMN];
const OLD_CONDOM_COLUMNS = [...BASE_COLUMNS, 'virtual_self_consumption', 'tip_fee', 'withdrawal_fee', 'tip_benefit', 'cacv_benefit', 'withdrawal_benefit', 'total_benefit', DETAILS_COLUMN];
const NEW_CONDOM_COLUMNS = [MEMBERS_COLUMN, 'pod_roles', 'absorption_or_thousandths', 'tip_fee', 'tip_benefit', 'withdrawal_benefit', 'total_benefit', DETAILS_COLUMN];

const DIALOG_WIDTH = 800;

@Component({
    selector: 'app-ec-economics-redistributed',
    templateUrl: './ec-economics-redistributed.component.html',
    styleUrls: ['./ec-economics-redistributed.component.scss'],
    providers: [
        {
            provide: I18NMatPaginatorIntlConfig,
            useValue: {itemsPerPageLabel: 'Members per page'} as I18NMatPaginatorIntlConfig
        },
        {provide: MatPaginatorIntl, useClass: I18NMatPaginatorIntl, deps: [I18NService, I18NMatPaginatorIntlConfig]}
    ]
})
export class ECEconomicsRedistributedComponent implements OnInit, AfterViewInit, OnDestroy {
    private destroyed = new Subject<void>();
    private reloadPods: Subject<void> = new Subject<void>();
    private reloadMembers: Subject<void> = new Subject<void>();
    private reloadEconomicsData: Subject<void> = new Subject<void>();
    private reloadEconomics: Subject<void> = new BehaviorSubject<void>(null);
    private entityId: string;
    private templateEntity: HierarchyEntity = null;
    private templatePeriod: BillingPeriod = null;
    private algorithmSubj: BehaviorSubject<SelectedAlgorithm> = new BehaviorSubject<SelectedAlgorithm>(null);
    private responseErrors: EconomicsError[] = [];
    private activationDate: number = null;
    private now: Moment;
    private currentSelectedYear: number;
    private readonly nvp: NiceValuePipe;

    @ViewChild('paginator') private paginator: MatPaginator;
    @ViewChild('chooseAlgorithm') private algorithmDialog: TemplateRef<any>;
    @ViewChild('incentiveCalculation') private incentiveCalculationDialog: TemplateRef<any>;
    @ViewChild('changeCap') private capChangeDialog: TemplateRef<any>;
    @ViewChild('details') private detailsDialog: TemplateRef<any>;
    @ViewChild('ecWaitingForApproval') private ecWaitingForApprovalDialog: TemplateRef<any>;
    @ViewChild('spinner') private spinnerDialog: TemplateRef<any>;
    @ViewChild('newCondoExportEconomics') private newCondoExportEconomicsDialog: TemplateRef<any>;

    hierarchyEntity: Observable<HierarchyEntity> = null;
    entity: HierarchyEntity;
    timeZone: string = null;
    singleDate: Moment = null;
    response: ECEconomicsRedistributedResponse = null;
    billingPeriodCfg: BillingPeriodConfig = null;
    billingPeriod: BillingPeriod = {} as BillingPeriod;
    billingPeriodSubj: ReplaySubject<BillingPeriod> = new ReplaySubject<BillingPeriod>(1);
    algorithm: string = null;
    availableAlgorithms: string[];
    rows: BehaviorSubject<RedistributedRows> = new BehaviorSubject<RedistributedRows>(null);
    displayedColumns: string[] = DEFAULT_COLUMNS;
    ecMode: ECMode = null;
    futureEc = false;
    inactiveEc = false;
    templateIsDownloading = false;
    searchText = '';
    // searchSubj: BehaviorSubject<string>;
    sharingChart: Partial<ChartOptions>;
    participationChart: Partial<ChartOptions>;
    fanoParticipationChart: Partial<ChartOptions>;
    fixedAmountChart: Partial<ChartOptions>;
    sharingPerformanceChart: Partial<ChartOptions>;
    detailsButtonDisabled = false;
    communityNotConfigured = false;
    isWholeYear = false;
    higherRedistributableWarning = false;
    showComputationWarning = false;
    summaryResponseSubject: BehaviorSubject<YearSummaryConsolidation[]> = new BehaviorSubject<YearSummaryConsolidation[]>([]);
    strategyFeatures: ECEconomicsStrategyFeatures = null;
    strategy: string = null;
    exportCondoNewLayout: string;

    readonly DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    readonly DEFAULT_PAGE_SIZES = DEFAULT_PAGE_SIZES;
    readonly ALGORITHM_THOUSANDTH = ALGORITHM_THOUSANDTH;
    readonly ALGORITHM_MIXED = ALGORITHM_MIXED;
    readonly ALGORITHM_VAI = ALGORITHM_VAI;
    readonly ALGORITHM_CAPPED_VAI = ALGORITHM_CAPPED_VAI;
    readonly ALGORITHM_FANO = ALGORITHM_FANO;
    readonly ALGORITHM_CONDO_OLD = ALGORITHM_CONDO_OLD;
    readonly ALGORITHM_CONDO_NEW = ALGORITHM_CONDO_NEW;
    readonly THOUSANDTHS = THOUSANDTHS;
    readonly CAP = CAP_KEY;
    readonly CACV_STRING = CACV_STRING;
    readonly ECMode = ECMode;
    readonly MEMBERS_SHARE_COLUMN = MEMBERS_SHARE_COLUMN;
    readonly ECPodDataSource = ECPodDataSource;
    readonly ECSurplusPremiumRateScope = ECSurplusPremiumRateScope;
    readonly ECMemberSubjectClassification = ECMemberSubjectClassification;
    readonly isViewable = isViewable;
    readonly isUpdatable = isUpdatable;
    readonly isDefined = isDefined;
    readonly ECEconomicsFeatures = ECEconomicsFeatures;
    readonly ECMemberRelationType = ECMemberRelationType;
    readonly EC_FILE_EXPORT_CONDO_NEW_LAYOUT_1 = EC_FILE_EXPORT_CONDO_NEW_LAYOUT_1;
    readonly EC_FILE_EXPORT_CONDO_NEW_LAYOUT_2 = EC_FILE_EXPORT_CONDO_NEW_LAYOUT_2;
    readonly EC_FILE_EXPORT_CONDO_NEW_LAYOUT_3 = EC_FILE_EXPORT_CONDO_NEW_LAYOUT_3;

    constructor(private readonly router: Router,
                private readonly configurationService: ConfigurationService,
                private readonly msgBoxService: MsgBoxService,
                private readonly i18n: I18NService,
                private readonly hierarchyService: HierarchyService,
                private readonly dialogService: DialogService,
                private readonly apiService: SmagApiService,
                private readonly computationService: ComputationStatusService,
                private readonly changeDetectorRef: ChangeDetectorRef,
                private readonly dialog: MatDialog) {
        this.nvp = new NiceValuePipe(i18n);
        // this.searchSubj = new BehaviorSubject<string>(null);
    }


    ngOnInit() {
        this.configurationService.timeConfig
            .pipe(first())
            .subscribe(timeCfg => {
                this.timeZone = timeCfg.time_zone;
                this.now = moment.tz(this.timeZone);
            });

        this.computationService.showComputingWarning
            .pipe(takeUntil(this.destroyed))
            .subscribe(bool => this.showComputationWarning = bool);

        // NOTE: as we store time range in URL, we need to avoid "navigation" to same entity when
        //       setting URL parameters for time-range
        this.hierarchyEntity = this.hierarchyService.selection.pipe(
            distinctUntilChanged((h1, h2) => h1?.id === h2?.id),
            shareReplay(1),
            takeUntil(this.destroyed)
        );
        this.hierarchyEntity.pipe(
            filter(he => he !== null),
            takeUntil(this.destroyed)
        ).subscribe(he => {
            this.entity = he;
            this.entityId = he.id;
            if (can(he.permissions, Permission.READ)) {
                this.loadECMode(he.id);
            }
        });

        this.hierarchyEntity.pipe(
            filter(hierarchyEntity => !!hierarchyEntity),
            switchMap(hierarchyEntity => can(hierarchyEntity.permissions, Permission.READ) ?
                this.apiService.getEntity(hierarchyEntity.id) : of(null)),
            takeUntil(this.destroyed)
        ).subscribe(entity => {
            this.activationDate = (entity as EnergyCommunity)?.activation_date || null;
            this.billingPeriodCfg = {
                pastDate: this.activationDate,
                futureDate: null
            };
            if (!isDefined(this.billingPeriodCfg.pastDate)) {
                this.inactiveEc = true;
                this.showWaitingForApprovalModal();
            } else {
                this.inactiveEc = false;
                if (this.billingPeriodCfg.pastDate > moment.tz(this.timeZone).valueOf()) {
                    this.futureEc = true;
                    this.showWaitingForApprovalModal();
                } else {
                    this.futureEc = false;
                }
            }
        });
    }

    ngAfterViewInit() {
        combineLatest([
            this.hierarchyEntity,
            this.billingPeriodSubj,
            this.configurationService.timeConfig,
            this.configurationService.economicsConfig,
            this.algorithmSubj,
            this.reloadEconomics,
            // this.searchSubj.pipe(debounceTime(DEBOUNCE_MILLIS))
        ]).pipe(takeUntil(this.destroyed))
            .subscribe(([hierarchyEntity,
                            billingPeriod,
                            timeCfg,
                            ecoCfg,
                            algo,
                            // searchText
                        ]) => {
                // TODO use searchText to filter member by name when be supports it
                const timeZone = timeCfg.time_zone;
                this.mkAvailableAlgorithms(hierarchyEntity, billingPeriod, ecoCfg);
                this.singleDate = moment.tz(billingPeriod.fromTime, timeZone);
                this.billingPeriod = billingPeriod;
                this.currentSelectedYear = moment.tz(billingPeriod.fromTime, this.timeZone).startOf('month').year();
                this.mkData(hierarchyEntity, billingPeriod);
            });

        merge(
            this.paginator.page,
            this.reloadPods.pipe(tap(() => this.paginator.firstPage()))
        ).pipe(
            startWith(undefined as unknown),
            switchMap(() => combineLatest([this.hierarchyEntity, this.billingPeriodSubj])),
            switchMap(([hierarchyEntity, billingPeriod]) => {
                    this.templateEntity = hierarchyEntity;
                    this.templatePeriod = billingPeriod;
                    this.reloadMembers.next();  // avoids multiples of the subsequent calls
                    return this.computationService
                        .checkComputationStatus(this.entity.id, moment.tz(billingPeriod.fromTime, this.timeZone).startOf('month').year())
                        .pipe(takeUntil(merge(this.destroyed, this.reloadMembers)),
                            switchMap(() => {
                                return this.paginator ?
                                    this.mkRows(hierarchyEntity,
                                        sanityFromTimeActivationDate(billingPeriod.fromTime, this.billingPeriodCfg.pastDate, this.timeZone),
                                        sanityToTime(this.timeZone, billingPeriod.toTime),
                                        this.paginator.pageIndex + 1,
                                        this.paginator.pageSize) :
                                    of(null as RedistributedRows)
                                        .pipe(startWith(null as RedistributedRows), // triggers spinner
                                            catchError(err => {
                                                this.msgBoxService.error(this.i18n.translate('An error occurred while retrieving members'), err);
                                                return of(null as RedistributedRows);
                                            }));
                            }));
                }
            ),
            takeUntil(this.destroyed),
            switchMap(rows => combineLatest([
                this.billingPeriodCfg.pastDate ?
                    mkConsolidatedMonths(this.entityId, this.billingPeriodCfg.pastDate, this.timeZone, this.apiService) :
                    of(null),
                of(rows)]))
        ).subscribe(([consolidation, rows]) => {
            if (consolidation) {
                this.summaryResponseSubject.next(consolidation);
            }
            if (rows) {
                this.rows.next(rows);
            }
        });
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    onChangeBillingPeriod(period: BillingPeriod) {
        this.billingPeriodSubj.next(period);
        this.isWholeYear = isWholeYearSelected(period.fromTime, period.toTime, this.activationDate, this.timeZone, period.type);
        this.router.navigate([],
            {
                queryParams: mkBillingPeriodParams(period),
                queryParamsHandling: 'merge'
            }).then();
    }

    canChooseAlgorithm(entity: HierarchyEntity) {
        if (this.strategy === STRATEGY_OLD_CONDO || this.strategy === STRATEGY_NEW_CONDO) {
            // ignore configuration error with old/new strategy
            return !this.isWholeYear || !isUpdatable(entity) || (this.performanceTotalPods === 0 || !this.performanceTotalPods);
        }
        return !this.isWholeYear || !isUpdatable(entity) || (this.performanceTotalPods === 0 || !this.performanceTotalPods) || this.communityNotConfigured;
    }

    onClickEditAlgorithm() {
        this.dialogService.open<any, SelectedAlgorithm>({
            template: this.algorithmDialog,
            context: {}
        }, {
            width: GIGA_CHAD_DIALOG_MAX_WIDTH,
        }).closed.then(algorithm => this.onAlgorithmSetUp(algorithm));
    }

    onClickIncentiveCalculation(algorithm: string) {
        this.dialog.open(this.incentiveCalculationDialog, {
            data: {algorithm},
            width: `${DEFAULT_DIALOG_MAX_WIDTH}px`,
            hasBackdrop: true
        }).afterClosed().subscribe();
    }

    // onClickClearSearchText() {
    //     this.searchText = '';
    //     this.paginator.firstPage();
    //     this.searchSubj.next(this.searchText);
    // }

    // onClickSearchText() {
    //     const search = this.cleanSearchText;
    //     if (search) {
    //         this.paginator.firstPage();
    //     }
    //     this.searchSubj.next(search);
    // }

    getLandRegistryDescription(member: RedistributedMember, pod: string): string | null {
        const memberPod = member.member?.pods.find(p => p.pod === pod);
        if (!memberPod) {
            return null;
        }
        return mkLandRegistryDataString(memberPod.land_registry_data, v => this.i18n.translate(v), false);
    }

    showWaitingForApprovalModal() {
        this.dialog.open(this.ecWaitingForApprovalDialog, {
            maxWidth: `${DEFAULT_DIALOG_MAX_WIDTH}px`,
            minWidth: `${DEFAULT_DIALOG_MIN_WIDTH}px`,
            hasBackdrop: true
        }).afterClosed().subscribe();
    }

    isExportSupported(): boolean {
        return this.strategy === STRATEGY_OLD_CONDO || this.strategy === STRATEGY_NEW_CONDO;
    }

    onClickExportEconomicsToFile() {
        this.templateIsDownloading = true;
        switch (this.strategy) {
            case STRATEGY_OLD_CONDO:
                this.exportEconomicsToFile(EC_FILE_EXPORT_CONDO_OLD_AUC_STANDARD, 'EXCEL');
                break;
            case STRATEGY_NEW_CONDO:
                this.exportCondoNewLayout = EC_FILE_EXPORT_CONDO_NEW_LAYOUT_1;
                this.dialogService.open<any, string>({
                    template: this.newCondoExportEconomicsDialog,
                    context: {},
                    title: this.i18n.translate('Select the billing report you want to download')
                }, {
                    width: DEFAULT_DIALOG_MAX_WIDTH
                }).closed
                    .then(templateType => templateType ? this.exportEconomicsToFile(templateType, 'CSV') : null)
                    .finally(() => this.templateIsDownloading = false);
                break;
            default:
                break;
        }
    }

    private exportEconomicsToFile(templateType: string, fileType: 'EXCEL' | 'CSV') {
        this.apiService.exportEconomicsToFile(templateType, this.templateEntity.id, this.templatePeriod.fromTime, this.templatePeriod.toTime, null)
            .subscribe(([data, filename]) => {
                downloadBlob(data, filename);
                this.templateIsDownloading = false;
                this.msgBoxService.info(this.i18n.translate('File downloaded!'));
            }, error => {
                this.templateIsDownloading = false;
                this.msgBoxService.error(this.i18n.translate(mkExportErrorMessage(error, fileType)));
            });
    }

    onClickEditCap(pod: ECEconomicsRedistributedPod) {
        this.dialogService.open<any, CAP>({
            template: this.capChangeDialog,
            context: {pod},
            title: this.i18n.translate('Set up the CAP threshold')
        }, {
            width: CHAD_DIALOG_MAX_WIDTH
        }).closed.then(cap => {
            if (cap) {
                let yearlyValue: YearlyValue;
                if (isNumber(cap.threshold)) {
                    yearlyValue = {
                        name: REDISTRIBUTION_SETTINGS,
                        object_id: cap.POD,
                        object_type: ValueObjectType.EC_POD,
                        year: cap.year,
                        value: {cap: cap.threshold / 100},
                    } as YearlyValue;
                } else {
                    yearlyValue = {
                        name: REDISTRIBUTION_SETTINGS,
                        object_id: cap.POD,
                        object_type: ValueObjectType.EC_POD,
                        year: cap.year,
                        value: {},
                    } as YearlyValue;
                }
                this.apiService.setYearlyValue(yearlyValue).then(() => {
                        this.msgBoxService.info(this.i18n.translate('CAP set up correctly'));
                        this.reloadPods.next();
                        this.reloadEconomics.next();
                    }
                ).catch(err => this.msgBoxService.error(this.i18n.translate('An error occurred while setting CAP'), err));
            }
        });
    }

    showDetailsButton(member: RedistributedMember): boolean {
        if (!member.pod && this.algorithm !== ALGORITHM_CONDO_NEW) {
            return false;
        }
        if (this.algorithm === ALGORITHM_CONDO_NEW) {
            // for condo new algo, details are available for POD holders
            // details are also shown for SEU PODs (member treated as an effective HOLDER)
            if (member.pod) {
                return this.getMemberPodRoles(member.pod).includes(ECMemberRelationType.HOLDER) || member.pod.seu;
            }
            // for condo new algo, details are available for owners of seu pus
            return this.isOnlyMemberRow(member) && member.propertyUnit?.seu;
        }
        return true;
    }

    showDetailsDialog(member: RedistributedMember) {
        this.detailsButtonDisabled = true;
        const isPu = this.algorithm === ALGORITHM_CONDO_NEW && this.isOnlyMemberRow(member) && member.propertyUnit?.seu;

        if (!isPu) {
            this.apiService.findEntityByPOD(member.pod.pod)
                .pipe(
                    switchMap(resp => forkJoin([this.apiService.getECPod(this.entity.id, resp.id),
                        of(this.entity.children.find(child => child.id === resp.id))])))
                .subscribe(([pod, podEntity]) => {
                    this.mkCharts(this.nvp, member.pod);
                    this.dialog.open(this.detailsDialog, {
                        maxWidth: `${CHAD_DIALOG_MAX_WIDTH}px`,
                        minWidth: `${CHAD_DIALOG_MIN_WIDTH}px`,
                        hasBackdrop: true,
                        data: {
                            member,
                            podType: getPodType(podEntity, pod.pod as Pod),
                            podName: pod.name,
                            isPod: true,
                            relevantEnergy: member.pod.relevant_energy,
                            absorbedEnergy: member.pod.absorbed_energy
                        }
                    }).afterClosed().subscribe(() => this.detailsButtonDisabled = false);
                });
        } else {
            this.mkPuCharts(this.nvp, member.propertyUnit);
            this.dialog.open(this.detailsDialog, {
                maxWidth: `${CHAD_DIALOG_MAX_WIDTH}px`,
                minWidth: `${CHAD_DIALOG_MIN_WIDTH}px`,
                hasBackdrop: true,
                data: {
                    member,
                    puName: member.propertyUnit.name,
                    isPod: false,
                    relevantEnergy: member.propertyUnit.seu_relevant_energy,
                    absorbedEnergy: member.propertyUnit.seu_absorbed_energy
                }
            }).afterClosed().subscribe(() => this.detailsButtonDisabled = false);
        }
    }

    resetCap(pod: ECEconomicsRedistributedPod, date: Moment): CAP {
        return {
            POD: pod.pod,
            threshold: null,
            year: date.year(),
            month: date.month() + 1
        } as CAP;
    }

    getPersonalSharingCellClass(pod: ECEconomicsRedistributedPod) {
        if (pod.data_source === ECPodDataSource.STATISTICAL) {
            return 'base';
        } else if (pod.data_source === ECPodDataSource.FIELD) {
            if (pod.incentivation.performance === ECEconomicsPerformance.GOOD) {
                return 'good';
            } else if (pod.incentivation.performance === ECEconomicsPerformance.MEDIUM) {
                return 'medium';
            } else if (pod.incentivation.performance === ECEconomicsPerformance.BAD) {
                return 'bad';
            }
        }
        return '';
    }

    getPersonalSharingCellIcon(pod: ECEconomicsRedistributedPod) {
        return this.getPersonalSharingCellClass(pod) + '-icon';
    }

    getAbsorptionParticipation(pod: ECEconomicsRedistributedPod) {
        return pod.relevant_energy * 100 / this.response.shared_energy;
    }

    getPuAbsorptionParticipation(pu: ECEconomicsRedistributedPropertyUnit) {
        return pu.seu_relevant_energy * 100 / this.response.shared_energy;
    }

    getFanoAbsorptionParticipation(pod: ECEconomicsRedistributedPod) {
        const algorithm = pod.incentivation.algorithm as ECEconomicsFanoRedistributedPodIncentivationAlgorithm;
        return isDefined(algorithm.performance) ? algorithm.performance * 100 : 0;
    }

    getOldCondoTotalBenefit(algorithm: ECEconomicsOldCondoRedistributedPodIncentivationAlgorithm) {
        return algorithm.tip_benefit + algorithm.cacv_benefit + algorithm.sold_energy_benefit;
    }

    getNewCondoPodTotalBenefit(algorithm: ECEconomicsNewCondoRedistributedPodIncentivationAlgorithm) {
        return algorithm.tip_benefit;
    }

    getNewCondoPropertyUnitTotalBenefit(algorithm: ECEconomicsNewCondoRedistributedPropertyUnitIncentivationAlgorithm) {
        return algorithm.tip_benefit + algorithm.sold_energy_benefit;
    }

    getMemberPodRoles(pod: ECEconomicsRedistributedPod): ECMemberRelationType[] {
        return [...new Set<ECMemberRelationType>((pod?.subject_relations || []).map(rel => rel.type))];
    }

    getMemberPropertyUnitRoles(propertyUnit: ECEconomicsRedistributedPropertyUnit): ECMemberRelationType[] {
        return [...new Set<ECMemberRelationType>((propertyUnit?.subject_relations || []).map(rel => rel.type))];
    }

    mkRoleName(role: ECMemberRelationType, short: boolean): string {
        switch (role) {
            case ECMemberRelationType.OWNER:
                return !short ? 'Owner' : 'Own.';
            case ECMemberRelationType.HOLDER:
                return !short ? 'Holder' : 'Hold.';
        }
    }

    isPropertyUnitRow(row: RedistributedMember) {
        return !row.pod && !row.member;
    }

    isPodRow(row: RedistributedMember) {
        return row.pod;
    }

    isOnlyMemberRow(row: RedistributedMember) {
        return row.member && !row.pod;
    }

    isAlsoMemberRow(row: RedistributedMember) {
        return row.member;
    }

    get showNullData(): boolean {
        return showNullData(this.inactiveEc, this.futureEc);
    }

    get keepYourSecrets(): boolean {
        if (this.strategy === STRATEGY_OLD_CONDO || this.strategy === STRATEGY_NEW_CONDO) {
            // ignore configuration errors on old/new condo
            return keepYourSecrets(this.inactiveEc, this.futureEc, false);
        }
        return keepYourSecrets(this.inactiveEc, this.futureEc, this.communityNotConfigured);
    }

    get absorptionRedistributedLabel(): string {
        if (this.strategy === STRATEGY_OLD_CONDO || this.strategy === STRATEGY_NEW_CONDO) {
            return 'Redistributed benefits__{redistributed}';
        }
        return 'Absorption redistributed';
    }

    get cellTextColor() {
        return this.response.gse ? 'txt-b-16-7' : 'txt-p-16-7';
    }

    get showMembersWarning() {
        return this.response.warnings?.some(w => w.code === REDISTRIBUTION_WARNING_PARTIALLY_RELEVANT_MEMBERS);
    }

    get performanceTotalPods() {
        return this.response.performance.statistical_pods + this.response.performance.field_pods;
    }

    get standardWidth(): number {
        return getAlgoDialogWidth(this.algorithm);
    }

    get isNoAlgorithm(): boolean {
        return isNoAlgorithm(this.response?.redistribution?.algorithm);
    }

    get isCondomNew(): boolean {
        return this.algorithm === ALGORITHM_CONDO_NEW;
    }

    get isCondomNewStrategy(): boolean {
        return this.strategy === STRATEGY_NEW_CONDO;
    }

    get isLayout3Disabled() {
        const activationDate = moment.tz(this.activationDate, this.timeZone);
        return this.now.year() === this.currentSelectedYear && activationDate.month() > this.now.month();
    }

    // get cleanSearchText() {
    //     return this.searchText.trim();
    // }

    private getPersonalSharing(pod: ECEconomicsRedistributedPod) {
        return pod.relevant_energy * 100 / pod.absorbed_energy;
    }

    private getPuPersonalSharing(pu: ECEconomicsRedistributedPropertyUnit) {
        return pu.seu_relevant_energy * 100 / pu.seu_absorbed_energy;
    }

    private mkECEconomicsRedistributionSettings(selectedAlgorithm: SelectedAlgorithm): ECEconomicsRedistributionSettings {
        if (selectedAlgorithm.type === ALGORITHM_THOUSANDTH) {
            return {algorithm: selectedAlgorithm.type} as ECEconomicsThousandthRedistributionSettings;
        } else if (selectedAlgorithm.type === ALGORITHM_VAI) {
            return {
                algorithm: selectedAlgorithm.type,
                fixed_part: selectedAlgorithm.fixedPart,
                split_consumers: selectedAlgorithm.splitConsumers
            } as ECEconomicsVAIRedistributionSettings;
        } else if (selectedAlgorithm.type === ALGORITHM_CAPPED_VAI) {
            return {
                algorithm: selectedAlgorithm.type,
                fixed_part: selectedAlgorithm.fixedPart,
                split_consumers: selectedAlgorithm.splitConsumers,
                global_cap_enabled: selectedAlgorithm.globalCapEnabled,
                global_cap: selectedAlgorithm.globalCap
            } as ECEconomicsCappedVAIRedistributionSettings;
        } else if (selectedAlgorithm.type === ALGORITHM_MIXED) {
            return {
                algorithm: selectedAlgorithm.type
            } as ECEconomicsMixedRedistributionSettings;
        } else if (selectedAlgorithm.type === ALGORITHM_FANO) {
            return {
                algorithm: selectedAlgorithm.type,
                founders_percentage: selectedAlgorithm.foundersPercentage,
                social_fund_percentage: selectedAlgorithm.socialFundPercentage,
                plants_percentage: selectedAlgorithm.plantsPercentage
            } as ECEconomicsFanoRedistributionSettings;
        } else if (selectedAlgorithm.type === ALGORITHM_CONDO_OLD) {
            return {
                algorithm: selectedAlgorithm.type,
                shared_energy_fee_value: selectedAlgorithm.tipFee,
                rei_fee_value: selectedAlgorithm.withdrawalFee,
                tip_benefit_value: selectedAlgorithm.tipBenefit,
                sold_energy_benefit_value: selectedAlgorithm.withdrawalBenefit,
                cacv_benefit_value: selectedAlgorithm.cacvBenefit
            } as ECEconomicsOldCondoRedistributionSettings;
        } else if (selectedAlgorithm.type === ALGORITHM_CONDO_NEW) {
            return {
                algorithm: selectedAlgorithm.type,
                management_fee_value: selectedAlgorithm.managementFee,
                sold_energy_benefit_value: selectedAlgorithm.soldEnergyBenefit
            } as ECEconomicsNewCondoRedistributionSettings;
        }
        // TODO add other algorithms when supported
    }

    private async mkSurplusPremiumRate(selectedAlgorithm: SelectedAlgorithm): Promise<ECSurplusPremiumRate> {
        // some algorithms may rely on custom logic for surplus premium rate mode determination
        let mode: ECSurplusPremiumRateScope;
        if (selectedAlgorithm.type === ALGORITHM_CONDO_NEW) {
            mode = await this.getNewCondoSurplusPremiumRateMode();
            return ({mode});
        }
        if (isDefined(selectedAlgorithm.willNotRedistribute)) {
            mode = selectedAlgorithm.willNotRedistribute ?
                ECSurplusPremiumRateScope.ALLOCATED :
                ECSurplusPremiumRateScope.CONSUMER_REDISTRIBUTED;
        } else {
            mode = ECSurplusPremiumRateScope.UNDEFINED;
        }
        return Promise.resolve({mode});
    }

    private async getNewCondoSurplusPremiumRateMode(): Promise<ECSurplusPremiumRateScope> {
        const info = await this.apiService.getEconomicsStrategyInfo(this.entity.id, this.singleDate.year()).toPromise();
        if (info.strategy_type === STRATEGY_NEW_CONDO && !!(info as ECEconomicsCondoNewStrategyInfo).suggested_surplus_premium_rate_scope) {
            return (info as ECEconomicsCondoNewStrategyInfo).suggested_surplus_premium_rate_scope;
        }
        return ECSurplusPremiumRateScope.UNDEFINED;
    }

    private loadECMode(networkId: string) {
        this.apiService.communityPodsStatistics(networkId)
            .pipe(map(stats => mkMode(stats)))
            .subscribe(ecMode => this.ecMode = ecMode);
    }

    private mkAvailableAlgorithms(hierarchyEntity: HierarchyEntity,
                                  billingPeriod: BillingPeriod,
                                  ecoCfg: EconomicsConfig) {
        const year = moment.tz(billingPeriod.fromTime, this.timeZone).year();
        this.apiService.getEconomicsStrategyAlgorithms(hierarchyEntity.id, year)
            .subscribe(algorithms => {
                this.availableAlgorithms = ecoCfg.incentive_redistribution_algorithms
                    .filter(algo => algorithms.includes(algo));
            });
    }

    private mkData(entity: HierarchyEntity, billingPeriod: BillingPeriod) {
        this.response = null;
        if (entity?.type === EntityType.ENERGY_COMMUNITY && isViewable(entity)) {
            if (!this.inactiveEc && !this.futureEc) {
                this.reloadEconomicsData.next();
                this.computationService.checkComputationStatus(entity.id, moment.tz(billingPeriod.fromTime, this.timeZone).startOf('month').year())
                    .pipe(takeUntil(merge(this.destroyed, this.reloadEconomicsData)))
                    .subscribe(() => {
                        combineLatest([this.apiService.ecEconomicsRedistributed(entity.id, sanityFromTimeActivationDate(billingPeriod.fromTime,
                            this.billingPeriodCfg.pastDate, this.timeZone), sanityToTime(this.timeZone, billingPeriod.toTime)),
                            this.apiService.getEconomicsStrategyFeatures(entity.id, moment.tz(billingPeriod.fromTime, this.timeZone).year()),
                            this.apiService.getYearlyValue(mkYearlyValue(STRATEGY, null, entity.id, moment.tz(billingPeriod.fromTime, this.timeZone).year())),
                        ]).pipe(takeUntil(merge(this.destroyed, this.reloadEconomicsData)),
                            filter(r => r !== null))
                            .subscribe(([response, strategyFeatures, strategy]) => {
                                this.response = response;
                                this.strategy = strategy.value.strategy_type;
                                this.strategyFeatures = strategyFeatures;
                                this.responseErrors = this.response.errors ? this.response.errors : [];
                                this.communityNotConfigured = this.responseErrors
                                    .filter(err => err.type === EconomicsErrorType.MISSING_PARAM)
                                    .some(err =>
                                        err.metadata[ECO_ERROR_PARAM_KEY] === COSTS ||
                                        err.metadata[ECO_ERROR_PARAM_KEY] === EC_PLANTS_REI_REDISTRIBUTION ||
                                        err.metadata[ECO_ERROR_PARAM_KEY] === PLANT_TIP_QUOTE);
                                if (!response.redistribution) {
                                    this.displayedColumns = NULL_REDIST_COLUMNS;
                                    this.algorithm = null;
                                } else {
                                    this.algorithm = response.redistribution.algorithm;
                                    if (this.algorithm === ALGORITHM_THOUSANDTH) {
                                        this.displayedColumns = THOUSANDTH_COLUMNS;
                                    } else if (this.algorithm === ALGORITHM_VAI) {
                                        this.displayedColumns = VAI_COLUMNS;
                                    } else if (this.algorithm === ALGORITHM_CAPPED_VAI) {
                                        this.displayedColumns = CAPPED_VAI_COLUMNS;
                                    } else if (this.algorithm === ALGORITHM_MIXED) {
                                        this.displayedColumns = MIXED_COLUMNS;
                                    } else if (this.algorithm === ALGORITHM_NO_ALGORITHM) {
                                        this.displayedColumns = DEFAULT_COLUMNS;
                                        if (this.isWholeYear && isUpdatable(entity) && this.performanceTotalPods > 0 && !this.communityNotConfigured) {
                                            this.onClickEditAlgorithm();
                                        }
                                    } else if (this.algorithm === ALGORITHM_NO_ALGORITHM_OLD_CONDO || this.algorithm === ALGORITHM_NO_ALGORITHM_NEW_CONDO) {
                                        this.displayedColumns = DEFAULT_COLUMNS;
                                        if (this.isWholeYear && isUpdatable(entity) && this.performanceTotalPods > 0) {
                                            this.onClickEditAlgorithm();
                                        }
                                    } else if (this.algorithm === ALGORITHM_FANO) {
                                        this.displayedColumns = FANO_COLUMNS;
                                    } else if (this.algorithm === ALGORITHM_CONDO_OLD) {
                                        this.displayedColumns = OLD_CONDOM_COLUMNS;
                                    } else if (this.algorithm === ALGORITHM_CONDO_NEW) {
                                        this.displayedColumns = NEW_CONDOM_COLUMNS;
                                    }
                                }
                                // Set warning for higher redistributed compared to redistributable in case of mixed_algorithm
                                this.higherRedistributableWarning = response.warnings
                                    .some(warning => warning.code === REDISTRIBUTION_WARNING_MIXED_INSUFFICIENT_REVENUE);
                            });
                    });
            } else {
                this.generateInactiveEcoRedistributedData();
            }
        }
    }

    private generateInactiveEcoRedistributedData() {
        this.response = {
            incentivation: {} as ECEconomicsRedistributedIncentivation,
            performance: {} as ECEconomicsRedistributedPerformance,
            redistribution: {} as ECEconomicsRedistributionSettings,
            warnings: [],
            errors: [],
            absorbed_energy: null,
            effective_injected_energy: null,
            shared_energy: null,
            gse: null,
            surplus_premium_rate: {} as ECEconomicsSurplusPremiumRate
        };
    }

    private mkRows(entity: HierarchyEntity,
                   fromTime: number,
                   toTime: number,
                   page: number,
                   size: number): Observable<RedistributedRows> {
        const empty = of({members: [], total: 0} as RedistributedRows);
        // entity must be a viewable, active, but not waiting for activation, energy community
        if (!(entity?.type === EntityType.ENERGY_COMMUNITY && isViewable(entity) && (!this.inactiveEc && !this.futureEc))) {
            return empty;
        }
        return forkJoin([
            this.apiService.ecEconomicsRedistributedMembers(entity.id, fromTime, toTime, page, size),
            this.apiService.getNetwork(entity.id) as Observable<EnergyCommunityNetwork>
        ]).pipe(switchMap(([resp, net]) => {
            if (!resp.rows.length) {
                return empty;
            } else if (resp.rows[0].strategy === STRATEGY_NEW_CONDO) {
                return this.mkRedistributedPropertyUnits(resp, net);
            } else {
                return this.mkRedistributedMemberRows(resp, net);
            }
        }));
    }

    private mkRedistributedPropertyUnits(resp: ECEconomicsRedistributedRows, net: EnergyCommunityNetwork): Observable<RedistributedRows> {
        return forkJoin(this.mkRowsAndMembers(resp, net.network_id))
            .pipe(map(results => ({
                members: _.flatten(results.map(([row, members, showPuTip]) => mkPropertyUnits(row, members, showPuTip, net, s => this.i18n.translate(s)))),
                total: resp.total,
                errors: resp.errors
            })));
    }

    private mkRowsAndMembers(resp: ECEconomicsRedistributedRows, networkId: string): Observable<[ECEconomicsRedistributedNewCondoRow, ECMember[], boolean]>[] {
        return resp.rows.map((row: ECEconomicsRedistributedNewCondoRow) =>
            forkJoin([
                this.mkRedistributedPropertyUnitsMembers(row),
                this.showPuTipLoad(networkId, row)
            ]).pipe(map(([ecMembers, showPuTip]) => [row, ecMembers, showPuTip]))
        );
    }

    private mkRedistributedPropertyUnitsMembers(row: ECEconomicsRedistributedNewCondoRow): Observable<ECMember[]> {
        return forkJoin(row.members.length ?
            row.members.map(member => member.member_id ?
                this.apiService.loadMember(member.member_id) :
                of(null)) :
            [of(null)]);
    }

    private showPuTipLoad(networkId: string, row: ECEconomicsRedistributedNewCondoRow): Observable<boolean> {
        return this.apiService.getPodsByPropertyUnitData(networkId, {
            sheet: row.sheet,
            particle: row.particle,
            subdivision: row.subdivision
        }).pipe(map(result => result.results.some(member => member.seu)));
    }

    private mkRedistributedMemberRows(resp: ECEconomicsRedistributedRows, network: EnergyCommunityNetwork): Observable<RedistributedRows> {
        return forkJoin(resp.rows.map(redistributedMember => this.mkMembersTuples(redistributedMember)))
            .pipe(map(members => ({
                members: mkRedistributedMembers(members, network),
                total: resp.total,
                errors: resp.errors
            } as RedistributedRows)));
    }

    private mkMembersTuples(redistributedMember: any): Observable<[ECEconomicsRedistributedMember, ECMember]> {
        return (redistributedMember.member_id ?
                this.apiService.loadMember(redistributedMember.member_id) :
                of(null as ECMember)
        ).pipe(
            map(member => [redistributedMember as ECEconomicsRedistributedMember, member])
        );
    }

    private mkCharts(nvp: NiceValuePipe, pod: ECEconomicsRedistributedPod) {
        if (this.algorithm === ALGORITHM_THOUSANDTH ||
            this.algorithm === ALGORITHM_VAI ||
            this.algorithm === ALGORITHM_CAPPED_VAI ||
            this.algorithm === ALGORITHM_FANO ||
            this.algorithm === ALGORITHM_CONDO_OLD ||
            this.algorithm === ALGORITHM_CONDO_NEW) {
            this.mkPersonalSharingChart(nvp, pod);
        }
        if (this.algorithm === ALGORITHM_VAI ||
            this.algorithm === ALGORITHM_CAPPED_VAI ||
            this.algorithm === ALGORITHM_CONDO_OLD ||
            this.algorithm === ALGORITHM_CONDO_NEW) {
            this.mkAbsorptionParticipationChart(nvp, pod);
        }
        if (this.algorithm === ALGORITHM_FANO) {
            this.mkFanoAbsorptionParticipationChart(nvp, pod);
        }
        if (this.algorithm === ALGORITHM_MIXED) {
            this.mkFixedPercentageChart(nvp, pod);
            this.mkFixedSharingPerformanceChart(nvp, pod);
        }
    }

    private mkPuCharts(nvp: NiceValuePipe, pu: ECEconomicsRedistributedPropertyUnit) {
        if (this.algorithm !== ALGORITHM_CONDO_NEW) {
            return;
        }
        this.mkPuPersonalSharingChart(nvp, pu);
        this.mkPuAbsorptionParticipationChart(nvp, pu);
    }

    private mkFixedPercentageChart(nvp: NiceValuePipe, pod: ECEconomicsRedistributedPod) {
        // tslint:disable-next-line: no-string-literal
        const val = pod.redistribution['mixed_fixed'] !== null ? (pod.redistribution['mixed_fixed'] * 100) : null;
        this.fixedAmountChart = {
            chart: {type: 'donut', height: 90},
            colors: [environment.appColors.ecoYellow, environment.appColors.ecoEmpty],
            dataLabels: disableDataLabels(),
            apexLegends: disableLegend(),
            plotOptions: {
                pie: {
                    donut: {
                        size: '65%'
                    }
                }
            },
            labels: getTranslatedLabels(['Fixed percentage', ''], this.i18n),
            series: val ? [val, 100 - val] : [0, 0],
            tooltip: getNiceTooltip(nvp)
        };
    }

    private mkFixedSharingPerformanceChart(nvp: NiceValuePipe, pod: ECEconomicsRedistributedPod) {
        // tslint:disable-next-line: no-string-literal
        const val = pod.incentivation.algorithm['performance'] !== null ? (pod.incentivation.algorithm['performance'] * 100) : null;
        this.sharingPerformanceChart = {
            chart: {type: 'donut', height: 90},
            // tslint:disable-next-line: no-string-literal
            colors: [pod.redistribution['mixed_performance'] ? environment.appColors.ecoYellow : environment.appColors.ecoLegend, environment.appColors.ecoEmpty],
            dataLabels: disableDataLabels(),
            apexLegends: disableLegend(),
            plotOptions: {
                pie: {
                    startAngle: -90,
                    endAngle: 90,
                    donut: {
                        size: '65%'
                    }
                }
            },
            labels: getTranslatedLabels(['POD weight on total absorption', ''], this.i18n),
            series: val ? [val, 100 - val] : [0, 0],
            tooltip: getNiceTooltip(nvp),
            subtitle: {
                text: this.nvp.transform(val ? val : 0, '%', 2),
                align: 'center',
                offsetY: 35,
                floating: true,
                style: {
                    fontSize: '12px',
                    fontWeight: '400',
                    fontFamily: environment.fontFamily,
                    color: environment.appColors.ecoDarkLegend
                },
            }
        };
    }

    private mkPersonalSharingChart(nvp: NiceValuePipe, pod: ECEconomicsRedistributedPod) {
        const personalSharing = this.getPersonalSharing(pod);
        this.sharingChart = mkPersonalSharingChart(nvp, this.i18n, personalSharing);
    }

    private mkPuPersonalSharingChart(nvp: NiceValuePipe, pu: ECEconomicsRedistributedPropertyUnit) {
        const personalSharing = this.getPuPersonalSharing(pu);
        this.sharingChart = mkPersonalSharingChart(nvp, this.i18n, personalSharing);
    }

    private mkAbsorptionParticipationChart(nvp: NiceValuePipe, pod: ECEconomicsRedistributedPod) {
        this.participationChart = mkAbsorptionParticipationChart(nvp, this.i18n, this.getAbsorptionParticipation(pod));
    }

    private mkPuAbsorptionParticipationChart(nvp: NiceValuePipe, pu: ECEconomicsRedistributedPropertyUnit) {
        this.participationChart = mkAbsorptionParticipationChart(nvp, this.i18n, this.getPuAbsorptionParticipation(pu));
    }

    private mkFanoAbsorptionParticipationChart(nvp: NiceValuePipe, pod: ECEconomicsRedistributedPod) {
        this.fanoParticipationChart = mkAbsorptionParticipationChart(nvp, this.i18n, this.getFanoAbsorptionParticipation(pod), 'Participation in community');
    }

    private openSpinner(message: string) {
        const spinnerData = new BehaviorSubject<SpinnerData>({
            loading: true,
            loadingMessage: this.i18n.translate(message)
        });
        return this.dialogService.open<Subject<SpinnerData>, undefined>({
            template: this.spinnerDialog,
            context: spinnerData
        }, {
            width: DIALOG_WIDTH,
            hideCloseButton: true
        });
    }

    private onAlgorithmSetUp(algorithm: SelectedAlgorithm) {
        if (!algorithm) {
            return;
        }
        const spinner = this.openSpinner('We are updating the algorithm');
        const year = this.singleDate.year();
        const month = this.singleDate.month() + 1;

        from(this.mkSurplusPremiumRate(algorithm)).pipe(
            map(spr => ([spr, moment.tz(this.timeZone).valueOf()])), // get ts to check the correct computation
            switchMap(([spr, ts]: [ECSurplusPremiumRate, number]) => // set yearly values
                forkJoin([
                    this.apiService.setYearlyValue(mkYearlyValue(REDISTRIBUTION_SETTINGS, this.mkECEconomicsRedistributionSettings(algorithm), this.entityId, year)),
                    this.apiService.setYearlyValue(mkYearlyValue(SURPLUS_PREMIUM_RATE_MODE, spr, this.entityId, year)),
                    algorithm.type === ALGORITHM_CONDO_NEW ?
                        this.apiService.setYearlyValue(mkYearlyValue(SEU_FIX_QUOTA, algorithm.seuFixQuota, this.entityId, year)) :
                        of(null)
                ]).pipe(map(() => ts))),
            switchMap(ts => of(null).pipe(this.waitForComputationWithTimestampAndMaxTimeout(spinner, ts))), // wait for the correct computation to end
            switchMap(() => algorithm.template ? this.uploadAlgorithmTemplate(algorithm, year, month) : of(null)), // upload template only for relevant algorithms
            takeUntil(merge(this.destroyed, this.reloadEconomicsData)),
            catchError(err => {
                this.onAlgorithmSetUpFail(spinner, err);
                return EMPTY;
            })
        ).subscribe(() => {
            this.algorithmSubj.next(algorithm);
            this.reloadPods.next();
            spinner.context.next({
                loading: false,
                loadingMessage: this.i18n.translate('Algorithm changed successfully'),
            });
        });
    }

    private waitForComputationWithTimestampAndMaxTimeout(spinner: Dialog<Subject<SpinnerData>, undefined>, ts: number): OperatorFunction<any, ECComputedCommunityEconomics> {
        const year = moment.tz(this.billingPeriod.fromTime, this.timeZone).startOf('month').year();
        const maxTimeout = 60 * 1000; // 1 minute
        return pipe(
            switchMap(() => this.computationService.checkComputationStatus(this.entityId, year, ts, maxTimeout, this.timeZone)),
            takeUntil(merge(this.destroyed, this.reloadEconomicsData)),
            catchError(err => {
                this.onAlgorithmSetUpFail(spinner, err, false);
                return throwError(() => err);
            }));
    }

    private onAlgorithmSetUpFail(spinner: Dialog<Subject<SpinnerData>, undefined>, err: Error, showMessage: boolean = true) {
        const message = this.i18n.translate(mkAlgorithmSelectionErrorMessage(err));
        spinner.context.next({
            loading: false,
            loadingMessage: showMessage ? message : null,
            abort: true
        });
        if (showMessage) {
            this.msgBoxService.error(message, err);
        }
    }

    private uploadAlgorithmTemplate(algorithm: SelectedAlgorithm, year: number, month: number): Observable<void> {
        const templateType = mkTemplateType(algorithm.type);
        const file = {content: algorithm.template.file, filename: algorithm.template.name};
        return this.apiService.setECAlgorithmFile(this.entityId, templateType, year, month, file);
    }

}

function mkPropertyUnits(propertyUnit: ECEconomicsRedistributedNewCondoRow,
                         members: ECMember[],
                         showPuTip: boolean,
                         network: EnergyCommunityNetwork,
                         translate: (arg: string) => string): RedistributedMember[] {
    const memberPairs = propertyUnit.members.map((member, index) => [member, members[index]] as [ECEconomicsRedistributedMember, ECMember]);
    return mkMembersWithPropertyUnits(memberPairs, network, propertyUnit, showPuTip, translate);
}

function mkMembersWithPropertyUnits(members: [ECEconomicsRedistributedMember, ECMember][],
                                    network: EnergyCommunityNetwork,
                                    propertyUnit: ECEconomicsRedistributedNewCondoRow,
                                    showPuTip: boolean,
                                    translate: (arg: string) => string): RedistributedMember[] {
    const result = [];
    let propertyUnitHeaderAdded = false;
    if (members.length === 0) {
        // add only the pu header
        const redistributedPropertyUnit = mkEmptyPropertyUnit(showPuTip, propertyUnit, translate);
        if (!redistributedPropertyUnit) {
            return;
        }
        const puHeaderRow = {member: null, pod: null, propertyUnit: redistributedPropertyUnit} as RedistributedMember;
        result.push(puHeaderRow);
    } else {
        members.forEach(([redistMember, ecMember]) => {
            const redistributedPropertyUnit = mkPropertyUnit(ecMember, showPuTip, propertyUnit, translate);
            if (!redistributedPropertyUnit) {
                return;
            }
            // property unit is the "header" of the row group
            if (!propertyUnitHeaderAdded) {
                const puHeaderRow = {member: null, pod: null, propertyUnit: redistributedPropertyUnit} as RedistributedMember;
                result.push(puHeaderRow);
                propertyUnitHeaderAdded = true;
            }
            // member is the "subheader" of the row group
            const memberRoles = mkMemberPropertyUnitRoles(redistributedPropertyUnit);
            if (memberRoles.length) {
                result.push({
                    member: ecMember,
                    pod: null,
                    propertyUnit: redistributedPropertyUnit,
                    roles: memberRoles,
                    subjectName: getSubjectName(ecMember)
                } as RedistributedMember);
            }
            // pod is the "footer" of the row group
            redistMember.pods.forEach(pod => {
                result.push({
                    member: memberRoles.includes(ECMemberRelationType.OWNER) ? null : ecMember,
                    pod: mkPod(ecMember, pod),
                    propertyUnit: redistributedPropertyUnit,
                    isConsumer: isDefined(network.pods[pod.id]) && (isConsumer(network.pods[pod.id]) || isProsumer(network.pods[pod.id])),
                    roles: mkMemberPodRoles(pod),
                    subjectName: getSubjectName(ecMember)
                } as RedistributedMember);
            });
        });
    }
    return result;
}

function mkRedistributedMembers(members: [ECEconomicsRedistributedMember, ECMember][],
                                network: EnergyCommunityNetwork): RedistributedMember[] {
    return _.flatten(members.map(([redistMember, ecMember]) => {
        // member is the "header" of the row group
        const memberSubHeaderRow =
            {
                member: ecMember,
                pod: null,
                propertyUnit: null,
                roles: [],
                subjectName: getSubjectName(ecMember)
            } as RedistributedMember;
        // pod is the "footer" of the row group
        const podFooterRows = redistMember.pods.map(pod => {
            return {
                member: ecMember,
                pod: mkPod(ecMember, pod),
                propertyUnit: null,
                isConsumer: isDefined(network.pods[pod.id]) && (isConsumer(network.pods[pod.id]) || isProsumer(network.pods[pod.id])),
                roles: mkMemberPodRoles(pod),
                subjectName: getSubjectName(ecMember)
            } as RedistributedMember;
        });
        return [memberSubHeaderRow, ...podFooterRows].filter(row => row !== null);
    }));
}

function mkPropertyUnit(ecMember: ECMember,
                        seu: boolean,
                        propertyUnit?: ECEconomicsRedistributedNewCondoRow,
                        translate?: (arg: string) => string): RedistributedPropertyUnit {
    return showPropertyUnit(propertyUnit) ?
        {
            ...propertyUnit.members.find(m => m.member_id === ecMember.id).property_unit,
            name: mkLandRegistryDataString(propertyUnit, translate),
            seu
        } :
        null;
}

function mkEmptyPropertyUnit(seu: boolean,
                             propertyUnit?: ECEconomicsRedistributedNewCondoRow,
                             translate?: (arg: string) => string): RedistributedPropertyUnit {
    return showPropertyUnit(propertyUnit) ?
        {
            name: mkLandRegistryDataString(propertyUnit, translate),
            seu
        } as RedistributedPropertyUnit :
        null;
}

function mkPod(member: ECMember, pod: ECEconomicsRedistributedPod): RedistributedPod {
    return {
        ...pod,
        seu: !!member.pods.find(p => p.pod === pod.pod)?.seu,
    };
}

function mkMemberPodRoles(pod: ECEconomicsRedistributedPod): ECMemberRelationType[] {
    return [...new Set<ECMemberRelationType>((pod?.subject_relations || []).map(rel => rel.type))];
}

function mkMemberPropertyUnitRoles(propertyUnit: ECEconomicsRedistributedPropertyUnit): ECMemberRelationType[] {
    return [...new Set<ECMemberRelationType>((propertyUnit?.subject_relations || []).map(rel => rel.type))];
}

function mkAlgorithmSelectionErrorMessage(err: Error): string {
    // NOTE: economics-server provides its own set of error codes
    const code = errorCode(err);
    switch (code) {
        case EconomicsErrorCode.INVALID_THOUSANDTHS:
        case EconomicsErrorCode.INVALID_THOUSANDTHS_AT_ROW:
            return 'Thousandths must be > 0 and < 1000 for every POD';
        case EconomicsErrorCode.INVALID_TOTAL_THOUSANDTHS:
            return 'Total thousandths must be < 1000';
        case EconomicsErrorCode.INVALID_TOTAL_CAP:
            return 'Total CAP for consuming PODs must be >= 100%';
        case EconomicsErrorCode.INVALID_FIXED_AMOUNT:
            return 'Invalid fixed amount';
        case EconomicsErrorCode.INVALID_FIXED_PERCENTAGE:
            return 'Invalid fixed percentage';
        case EconomicsErrorCode.INVALID_TOTAL_FIXED_INCENTIVE:
            return 'Total fixed incentive has a percentage higher than 100%';
        case EconomicsErrorCode.INVALID_PERFORMANCE_INCENTIVE:
            return 'Invalid performance incentive';
        case EconomicsErrorCode.INVALID_LAND_REGISTRY_DATA_AT_ROW:
            return 'Land registry sheet, particle, and subdivision are mandatory';
        case EconomicsErrorCode.MULTIPLE_PODS_WITH_SAME_LAND_REGISTRY_DATA:
            return 'Two PODs cannot share the same land registry data';
        default:
            return 'An error occurred while choosing the algorithm';
    }
}

function mkExportErrorMessage(err: Error, fileType: 'EXCEL' | 'CSV'): string {
    // NOTE: economics-server provides its own set of error codes
    const code = errorCode(err);
    switch (code) {
        case EconomicsErrorCode.INTRA_YEAR_SUBJECT_CHANGE:
            return 'Unsupported intra-year holder/owner subject change';
        default:
            return fileType === 'CSV' ? 'An error occurred while exporting to CSV' : 'An error occurred while exporting to Excel';
    }
}

function mkTemplateType(algorithmType: string): string {
    switch (algorithmType) {
        case ALGORITHM_THOUSANDTH:
            return EC_FILE_THOUSANDTHS;
        case ALGORITHM_MIXED:
            return EC_FILE_MIXED;
        case ALGORITHM_CONDO_NEW:
            return EC_FILE_THOUSANDTHS; // condo new uses thousandths as well
    }
}

